export const IS_DEV = process.env.NODE_ENV === 'development';
export const yandexMetrikaId = 64765357;
export const authLink = 'https://business.invoicebox.ru/Login?utm_source=aeroexpress_header';
export const registerLink = 'https://business.invoicebox.ru/Register?utm_source=aeroexpress_header';
export const hotelOtelLink = 'https://hotelotel.ru/direction/1278-moskva?utm_source=aeroexpress_main';
export const businessInvoiceboxLink = 'https://business.invoicebox.ru/?utm_source=aeroexpress_main';
export const troikaBusinessLink = 'https://troika.invoicebox.ru/?utm_source=aeroexpress_main';

export const LAST_AVAILABLE_DEPART_DAY = new Date(Date.now() + 270 * 24 * 60 * 60 * 1000);
